import {ISolicitacaoItem} from "@models/solicitacoes/solicitacoes.ts";
import {IItensSolicitacaoFilters} from "@models/solicitacoes/solicitacaoItemDto.ts";
import React, {useEffect, useState} from "react";
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {SolicitacaoItemInformacaoRow,} from "@components/solicitacoes/itens/SolicitacaoItemInformacao.tsx";
import {DefaultPageProps} from "@models/DefaultProps.ts";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {useSolicitacao} from "@components/solicitacoes/hooks/useSolicitacao.tsx";
import {ISolicitacaoItemValor} from "@components/solicitacoes/dto/models/ISolicitacaoItemValor.ts";

interface SolicitacaoItensPageProps extends DefaultPageProps {
    filtros?: IItensSolicitacaoFilters,
    slotProps?: {
        itemInfo?: {
            EndComponent?: (item: ISolicitacaoItem) => React.ReactNode
        }
    }
}

export const SolicitacaoItensPage: React.FC<SolicitacaoItensPageProps> = (props) => {
    const {getItens} = useSolicitacao()
    const [itens, setItens] = useState<ISolicitacaoItemValor[]>([]);
    const [pagination, setPagination] = useState<IPagination>({page: 0, pageSize: 10});
    const [filtros] = useState(props.filtros);

    useEffect(() => {
            if (pagination.page == 0) {
                setPagination({...pagination, page: 1});
                return;
            }

            setPagination(prev => ({...prev, loading: true}));
            getItens({
                idSolicitacao: filtros?.idSolicitacao?.[0] ?? 0,
                contaOrcamentos: true,
                contaReferencias: true
            }, pagination).then(x => {
                if (x.items != null) {
                    setItens(x.items);
                }
                setPagination(prev => ({...prev, ...x.pagination}));
            }).finally(() => {
                setPagination(prev => ({...prev, loading: false, ignoreCache: false}))
            })
        },
        [pagination.page, pagination.ignoreCache == true],
    );


    return (<DefaultContainer pageProps={{pagination, setPagination}}>
        <TableContainer>
            <Table size={'small'} stickyHeader>
                <TableHead>
                    <TableRow>
                        {/*<TableCell>Id</TableCell>*/}
                        <TableCell>Produto</TableCell>
                        <TableCell>Estimado</TableCell>
                        <TableCell>Solicitado</TableCell>
                        <TableCell>Links</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell align={'right'}>Mais</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {itens.map((x) => {
                        return <SolicitacaoItemInformacaoRow value={x}
                                                             key={x.id}
                                                             EndComponent={props.slotProps?.itemInfo?.EndComponent}/>;
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    </DefaultContainer>);
};